/**
 * How many collision columns a dragged appointment spans, derived from the
 * resource/user order carried on its drag payload. Returns null when neither is
 * present, so callers can skip column work instead of reading `.length` off an
 * undefined value (Sentry LIME-CLIENT-15V).
 */
export function dragColumnSpan(
  currentResources: readonly unknown[] | undefined,
  currentUsers: readonly unknown[] | undefined,
): number | null {
  if (currentResources) return currentResources.length;
  if (currentUsers) return currentUsers.length;
  return null;
}
